<template>
    <a id="cookie-revoke-button" href="javascript:void(0);" class="btn btn-primary border-0 rounded-0" aria-label="View cookie settings" data-cc="c-settings">
        <span class="cookie-revoke-icon"><i class="fa fa-fingerprint fa-2x"></i></span>
    </a>
</template>

<script>

// https://github.com/orestbida/cookieconsent

export default {
    data() {
        return {
            locale: localStorage.getItem('locale'),
            domain: (new URL(window.location)).hostname,
        }
    },

    props: {
        app: {
            type: String,
            required: true
        },
        gtm: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: true
        }
    },

    mounted() {
        this.getCookieConsent();
    },

    methods: {

        getCookieConsent() {
            const cookieConsent = window.initCookieConsent();

            cookieConsent.run({
                current_lang: 'de',
                autoclear_cookies: true,
                delay: 1000,
                cookie_name: 'cc_netwaves',
                mode: 'opt-in',
                categories: [
                    "necessary",
                    "forms",
                    "fonts",
                    "maps",
                    "recaptcha",
                    "analytics",
                    "targeting"
                ],

                onAccept: (cookie) => {
                    if (cookieConsent.allowedCategory('analytics')) {
                        console.log('ANALYTICS OK');
                        this.setGTM();
                    }

                    if (cookieConsent.allowedCategory('targeting')) {
                        console.log('MARKETING OK');
                    }
                },

                onChange: (cookie, changed_preferences) => {
                    if (changed_preferences.indexOf('analytics') > -1) {
                        if (!cookieConsent.allowedCategory('analytics')) {
                            window.dataLayer = window.dataLayer || [];

                            function gtag() {
                                window.dataLayer.push(arguments);
                            }

                            gtag('consent', 'denied', {
                                'ad_storage': 'denied',
                                'analytics_storage': 'denied'
                            });
                        }
                    }
                },

                gui_options: {
                    consent_modal: {
                        layout: 'box',                  // box/cloud/bar
                        position: 'bottom right',      // bottom/middle/top + left/right/center
                        transition: 'zoom'             // zoom/slide
                    }
                },

                languages: {
                    de: {
                        consent_modal: {
                            title: this.data.consent_modal.title,
                            description: this.data.consent_modal.description + '<br>' + '<button type="button" data-cc="c-settings" class="cc-link mt-2">' + this.data.consent_modal.button + '</button>',
                            primary_btn: {
                                text: this.data.consent_modal.primary_btn,
                                role: 'accept_all'              // 'accept_selected' or 'accept_all'
                            },
                            secondary_btn: {
                                text: this.data.consent_modal.secondary_btn,
                                role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                            }
                        },
                        settings_modal: {
                            title: this.data.settings_modal.title,
                            save_settings_btn: this.data.settings_modal.save_settings_btn,
                            accept_all_btn: this.data.settings_modal.accept_all_btn,
                            reject_all_btn: this.data.settings_modal.reject_all_btn,
                            close_btn_label: this.data.settings_modal.close_btn_label,
                            cookie_table_headers: [
                                {col1: 'Name'},
                                {col2: 'Domain'},
                                {col3: 'Expiration'},
                                {col4: 'Description'}
                            ],
                            blocks: [
                                // POPUP BOX
                                {
                                    title: this.data.blocks.popup_title,
                                    description: this.data.blocks.popup_description,
                                }, {
                                // SYSTEM COOKIE
                                    title: this.data.blocks.necessary_title,
                                    description: this.data.blocks.necessary_description,
                                    toggle: {
                                        value: 'necessary',
                                        enabled: true,
                                        readonly: true
                                    },
                                    cookie_table: [
                                        {
                                            col1: 'cc_netwaves',
                                            col2: 'hoesele.com',
                                            col3: '30 days',
                                            col4: 'This is the default Website Session Cookie, where language selection and site settings will be stored.',
                                        },
                                    ]
                                }, {
                                // FORMS FONTS
                                    title: this.data.blocks.forms_title,
                                    description: this.data.blocks.forms_description,
                                    toggle: {
                                        value: 'forms',
                                        enabled: true,
                                        readonly: true
                                    },
                                    cookie_table: [
                                        {
                                            col1: 'XSRF',
                                            col2: 'hoesele.com',
                                            col3: '60 minutes',
                                            col4: 'This is the default Form Value Cookie, to prevent fraud attacks.',
                                        },
                                    ]
                                }, {
                                    // GOOGLE TOOLS
                                    title: this.data.blocks.tools_title,
                                    description: this.data.blocks.tools_description,
                                    toggle: {
                                        value: 'fonts',
                                        enabled: true,
                                        readonly: true
                                    },
                                }, {
                                // GOOGLE FONTS
                                //     title: this.data.blocks.fonts_title,
                                //     description: this.data.blocks.fonts_description,
                                //     toggle: {
                                //         value: 'fonts',
                                //         enabled: true,
                                //         readonly: true
                                //     },
                                }, {
                                // GOOGLE MAPS
                                //     title: this.data.blocks.maps_title,
                                //     description: this.data.blocks.maps_description,
                                //     toggle: {
                                //         value: 'maps',
                                //         enabled: true,
                                //         readonly: true
                                //     },
                                }, {
                                // GOOGLE RECAPTCHA
                                //     title: this.data.blocks.recaptcha_title,
                                //     description: this.data.blocks.recaptcha_description,
                                //     toggle: {
                                //         value: 'recaptcha',
                                //         enabled: true,
                                //         readonly: true
                                //     },
                                }, {
                                // GOOGLE ANALYTICS
                                    title: this.data.blocks.analytics_title,
                                    description: this.data.blocks.analytics_description,
                                    toggle: {
                                        value: 'analytics',
                                        enabled: true,
                                        readonly: false
                                    },
                                    cookie_table: [
                                        {
                                            col1: '_ga',
                                            col2: 'google.com',
                                            col3: '2 Years',
                                            col4: 'This is the GA4 Google Analytics Cookie, informations will be transferred anonymously.',
                                        },
                                    ]
                                },{
                                // GOOGLE ADWORDS
                                //     title: this.data.blocks.targeting_title,
                                //     description: this.data.blocks.targeting_description,
                                //     toggle: {
                                //         value: 'targeting',
                                //         enabled: true,
                                //         readonly: false
                                //     }
                                }, {
                                // POLICY LINK AND DESCRIPTIONS
                                    title: this.data.blocks.contact_title,
                                    description: this.data.blocks.contact_description,
                                }
                            ]
                        }
                    }
                }
            })
        },

        setGTM() {
            if(this.gtm) {
                // bei vue componenten immer arrow functions verwenden, weil du ansonsten das "this" nicht im context hast und "this.gtm" aus diesem grund "null" returned
                ((w,d,s,l,i) => {
                    w[l] = w[l] || [];
                    w[l].push({
                        'gtm.start': new Date().getTime(),event:'gtm.js'});
                    var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l !== 'dataLayer' ? '&l=' + l:'';
                    j.async = true;
                    j.defer = true;
                    j.type = 'text/javascript';
                    j.dataset.cookiecategory = 'analytics'; // data-cookiecategory="analytics"
                    j.src = 'https://www.googletagmanager.com/gtm.js?id='+this.gtm+i+dl;
                    f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','');
            }
        }
    }
}
</script>
